export function shuffleArray(array) {
    return array.map(function (n) { return [Math.random(), n] })
        .sort().map(function (n) { return n[1] });
}